module.exports = __webpack_public_path__ + "static/media/bg-ativacao.a56b505b.jpeg";